import { render, staticRenderFns } from "./ChannelFilter.vue?vue&type=template&id=0a99bc7a&scoped=true&"
import script from "./ChannelFilter.vue?vue&type=script&lang=js&"
export * from "./ChannelFilter.vue?vue&type=script&lang=js&"
import style0 from "./ChannelFilter.vue?vue&type=style&index=0&id=0a99bc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99bc7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
